import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { FormatDate, Text } from '@reveni-io/reveni-ui'

import SentimentTag from '@/metrics/pages/ReasonMetricDetailPage/SentimentTag/SentimentTag'
import routes from '@/Router/routes.constants'

import { getSentimentLabel } from './helpers'
import * as Styles from './styles'

const NoteCard = ({ note }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const sentimentLabel = getSentimentLabel(note.sentiment, theme)
  const returnDetailPath = routes.transactionDetailPage.replace(':id', note.return_id)

  return (
    <Styles.Container>
      <Styles.TopRow>
        <Styles.NoteText type="bodyMRegular">“{note.note_text}”</Styles.NoteText>
        {sentimentLabel && <SentimentTag type={note.sentiment} label={t(sentimentLabel)} />}
      </Styles.TopRow>
      <Styles.BottomRow>
        <Styles.ExternalLink href={returnDetailPath} target="_blank" rel="noopener noreferrer">
          <Text type="linkM">{note.order_name}</Text>
        </Styles.ExternalLink>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          ·
        </Text>
        <Text type="allCapsM" color={theme.colors.text.muted}>
          <FormatDate year="numeric" month="short" day="numeric">
            {note.return_date}
          </FormatDate>
        </Text>
      </Styles.BottomRow>
    </Styles.Container>
  )
}

export default NoteCard
